import { defineStyle, defineStyleConfig } from "@chakra-ui/react";

const baseStyle = defineStyle({
  borderRadius: "50px",
  padding: 0,
});

const primaryStyle = defineStyle(({ colorScheme }) => ({
  borderColor: `${colorScheme}.500`,
  borderStyle: "solid",
  borderWidth: "1px",
  color: `${colorScheme}.500`,
  fontWeight: "bold",
  justifyContent: "center",
  _active: {
    backgroundColor: `${colorScheme}.500`,
    color: "white",
  },
  _hover: {
    backgroundColor: `${colorScheme}.100`,
  },
}));

const secondaryStyle = defineStyle(({ colorScheme }) => ({
  backgroundColor: `${colorScheme}.600`,
  borderRadius: "5px",
  color: `white`,
  fontWeight: "bold",
  justifyContent: "center",
  _active: {
    backgroundColor: `${colorScheme}.100`,
  },
  _hover: {
    backgroundColor: `${colorScheme}.400`,
  },
}));

const buttonTheme = defineStyleConfig({
  baseStyle,
  defaultProps: {
    colorScheme: "blue",
    size: "xs",
  },
  variants: {
    primary: primaryStyle,
    secondary: secondaryStyle,
  },
});

export default buttonTheme;
